import { render, staticRenderFns } from "./Producoes.vue?vue&type=template&id=ab452d24"
import script from "./Producoes.vue?vue&type=script&lang=js"
export * from "./Producoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports